var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoFinytBlanco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 600,
    viewBox: "0 0 600 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1658_1325)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 188.363V201.704L22.4405 208.145L43.6402 214.407H68.2125L92.7848 214.455L92.9293 194.714L93.0257 175.021H47.0128H1V188.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.346 206.234V237.494L142.895 242.848C153.007 245.731 162.49 248.399 162.49 248.399C162.49 248.399 162.89 244.396 162.89 211.874V175.022H143.618H124.346V206.234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.485 175.02C207.292 175.164 207.217 194.857 207.217 218.326C207.217 258.525 207.265 261.058 208.084 261.488C208.999 261.966 270.43 279.747 270.575 279.556C270.623 279.508 266.046 262.779 260.409 242.417C254.771 222.055 248.267 198.538 245.954 190.173L241.763 175.021H224.803C215.504 175.021 207.485 175.02 207.485 175.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.789 229.415V283.857L299.388 288.064C307.386 290.358 315.288 292.652 316.974 293.13L319.961 293.991V234.482V175.021H302.375H284.789V229.415Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.764 175.021C352.764 175.165 359.226 200.307 367.224 230.563C375.174 260.867 383.317 291.889 385.292 299.536C387.316 307.136 389.098 313.541 389.291 313.78C389.676 314.163 428.944 325.586 429.908 325.586C430.293 325.586 431.016 323.674 431.787 320.424C432.461 317.604 441.278 283.858 451.396 245.429C461.514 206.999 469.794 175.165 469.794 175.021C469.794 175.021 461.226 174.973 450.867 175.021H432.129L422.295 216.941C416.995 239.836 412.37 259.195 412.032 259.959C411.454 261.202 411.358 261.25 410.78 260.389C410.057 259.434 410.442 260.963 398.879 211.109L390.429 175.021H371.596C361.189 174.973 352.764 175.021 352.764 175.021Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.072 194.857V214.693H507.14H525.208V283.953V353.213L526.798 353.738C529.352 354.551 563.271 364.302 563.512 364.302C563.656 364.302 563.753 330.652 563.753 289.497V214.693H582.062H600.37V194.857V175.02H544.721H489.072V194.857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 330.796V436H20.2724H39.5448L39.6412 379.216L39.7857 322.479L57.7572 322.336L75.6805 322.24V302.643V283.045L57.7572 282.95L39.7857 282.806L39.6412 259.767V237.282C39.6412 237.282 29.9568 233.956 20.2724 231.184C10.588 228.412 1 225.718 1 225.718C1 225.718 1 230.849 1 330.796Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.346 348.768C124.397 382.834 124.346 436 124.346 436H143.619H162.891L162.795 354.169L162.65 272.338L144.101 266.937C133.886 263.974 124.357 261.74 124.357 261.74C124.357 261.74 124.296 314.781 124.346 348.768Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.316 360.574L207.488 435.846L225.191 435.904L242.873 436V365.784V295.521L239.645 294.565C224.372 290.119 207.99 285.435 207.653 285.435C207.412 285.435 207.268 318.798 207.316 360.574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.688 298.15C247.929 298.914 256.505 329.84 266.72 366.931C276.934 403.975 285.414 434.709 285.558 435.14C285.799 435.952 287.052 436 302.904 436H319.96L319.863 376.873L319.719 317.699L302.855 312.824C293.605 310.147 285.703 307.9 285.414 307.9C284.932 307.9 284.788 309.717 284.788 315.309V322.718H283.631C282.379 322.718 282.716 323.578 279.247 310.72L277.849 305.606L263.395 301.448C255.397 299.105 248.507 297.146 248.074 297.002C247.351 296.811 247.303 297.002 247.688 298.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.941 339.16C391.845 339.447 391.797 361.29 391.845 387.723L391.99 435.76H411.262H430.534V392.742V349.723L411.358 344.179C398.928 340.594 392.086 338.825 391.941 339.16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.213 406.604V436H544.485H563.758V412.149V388.297L562.216 387.771C559.277 386.863 525.743 377.208 525.502 377.208C525.309 377.208 525.213 390.448 525.213 406.604Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1658_1325"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 600,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFinytBlanco);
export default __webpack_public_path__ + "static/media/logo-finyt-blanco.c5090b3216110ba209ad59bc37c4f505.svg";
export { ForwardRef as ReactComponent };